import React, { useEffect } from 'react';
import DisplayLongDescriptionAndVariantMFRName from "./DisplayLongDescriptionAndVariantMFRName";
import Cart from "@system/config/cart";
import noImage from 'src/assets/images/noimage.png'
import NavigateToProductDetail from "./NavigateToProductDetail";
import System from 'src/helper/system';
import { useProductStore } from 'src/hooks/product';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Constants from 'src/helper/Constants';
import { useSystem } from "src/hooks/system";
import { useCartStore } from 'src/hooks/cart';

const AddedToCartNotification = (props) => {
    const { data, SetStatus } = props;
    const currentProductData = data?.data?.server_response?.data || {}
    const [{ productList, model_ProductCompare_data }] = useProductStore();
    const [{ }, { fetch_cart_data }, { }] = useCartStore()
    const shortDes = productList[currentProductData?.itemNumber]?.ShortDescription || model_ProductCompare_data[currentProductData?.itemNumber]?.ShortDescription
    const [,{ get_quantity_format }] = useSystem();
    const onHide = () => {
        SetStatus(false)
    };
    const { translation: t } = System;
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();

    useEffect(() => {
        async function fetchData() {
            fetch_cart_data({ minicart: true })
        }
        fetchData()
    }, []);

    return (
        <>
            <div>
                {currentProductData &&
                    <div className="avnet-modal modal-680">
                        <div className="avnet-modal-inner">
                            {/* Modal Header */}
                            <button type="button"
                                onClick={() => {
                                    onHide()
                                }}
                                className="close py-3" data-dismiss="modal">×
                            </button>
                            <div className="modal-header justify-content-center mt-0">
                                <h3 className="pcn-modal-heading pl-5">{t('itemsAddedToCart')}</h3>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body mb-4">
                                <div className="clearfix" />
                                <div className="add-to-cart-list">
                                    <div className="add-to-cart-item bb-0">
                                        <div className="bs5 row m-0">
                                            <div className="col-auto p-0">
                                                <div className="add-to-cart-item-img">
                                                    <img className="img-fluid"
                                                        src={currentProductData.assetURL ? currentProductData.assetURL : noImage} />
                                                </div>
                                            </div>
                                            <div className="col-auto p-0">
                                                <div className="add-to-cart-item-info">
                                                    <NavigateToProductDetail
                                                        data={{ ManufacturerName: currentProductData?.manufacturerName, ERPMFRPartNumber: currentProductData?.erpMfrPartNumber, ItemNumber: currentProductData?.itemNumber, ERPPartNumber: currentProductData?.erpMfrPartNumber, seoItemNumber:currentProductData?.seoItemNumber }}>
                                                        <div className="text-blue">
                                                            <b>{currentProductData.erpMfrPartNumber}</b>
                                                        </div>
                                                    </NavigateToProductDetail>
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={{ ManufacturerName: currentProductData?.manufacturerName, ShortDescription: shortDes }} />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-auto mt-3 mt-sm-0 ms-auto p-0">
                                                <div className="add-to-cart-price">
                                                    <div className="add-to-cart-price-item">
                                                        <span>{t('unitPrice')}:</span>
                                                        <b>{System.getFormatNumber({ amount: Number(currentProductData.unitPrice), currency: System.getRegionCurrency() })}</b>
                                                    </div>
                                                    <div className="add-to-cart-price-item">
                                                        <span>{t('quantity')}:</span>
                                                        <b>{get_quantity_format(currentProductData.quantity)}</b>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.CORE) && (
                                        <div className="border-top-0 m-l-10">
                                            <div className="reserved-inventory-box w250">

                                                <div className="d-flex align-items-center justify-content-between">{t('currentStock')}
                                                    <span className="text-md-end">{get_quantity_format(get_inventory_by_id(currentProductData?.itemNumber)?.inventoryQty)}</span>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">{t('reservedForYou')}
                                                    <span>{get_quantity_format(get_inventory_by_id(currentProductData?.itemNumber)?.inventory)}</span>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">{t('totalAccessibleInventory')}
                                                    <span>{get_quantity_format(get_inventory_by_id(currentProductData?.itemNumber)?.totalInventory)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="text-end mt-2 font-12 cart-subtotal">
                                    <span> {t('itemSubTotal')} ({System.getRegionCurrency()}): &nbsp;
                                        <b>
                                            {System.getFormatNumber({ amount: Number(currentProductData.subtotal), maximumFractionDigits: 2, isDisplaySymbol: false, currency: System.getRegionCurrency() })}
                                        </b>
                                    </span>
                                </div>
                            </div>
                            {/* Modal footer */}
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button
                                        onClick={() => {
                                            onHide()
                                        }}
                                        type="button" className="bs5 btn btn-secondary btn-sm w145 px-0 text-uppercase"
                                        data-dismiss="modal">
                                        {t('continueShopping')}
                                    </button>
                                    <button type="button" className="bs5 btn btn-primary btn-sm w145 text-uppercase"
                                        onClick={() => {
                                            window.location.href = Cart.getCartPageRouteURL()
                                        }}
                                        data-dismiss="modal">
                                        {t('viewCart')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default AddedToCartNotification;